import type { RouteObject } from 'react-router-dom';
import { InternalRoute, PermissionRoute } from '@/features/auth';
import { FULL_WIDTH_PAGE } from '@/shared/layouts/pageLayout';
import { ServiceDetail } from '../pages/ServiceDetail';
import { ServiceEdit } from '../pages/ServiceEdit';
import { ItemList } from '../pages/ItemList';
import { ItemDetail } from '../pages/ItemDetail';
import { FeeList } from '../pages/FeeList';
import { FeeDetail } from '../pages/FeeDetail';
import { ConfigOptionList } from '../pages/ConfigOptionList';
import { ConfigOptionDetail } from '../pages/ConfigOptionDetail';
import { ProductList } from '../pages/ProductList';
import { ProductCreate } from '../pages/ProductCreate';
import { ProductDetail } from '../pages/ProductDetail';
import { ProductEdit } from '../pages/ProductEdit';
import { AddOnList } from '../pages/AddOnList';
import { AddOnCreate } from '../pages/AddOnCreate';
import { AddOnDetail } from '../pages/AddOnDetail';
import { AddOnEdit } from '../pages/AddOnEdit';
import { AddOnGroupList } from '../pages/AddOnGroupList';
import { AddOnGroupCreate } from '../pages/AddOnGroupCreate';
import { AddOnGroupDetail } from '../pages/AddOnGroupDetail';
import { AddOnGroupEdit } from '../pages/AddOnGroupEdit';
import { PlanList } from '../pages/PlanList';
import { PlanCreate } from '../pages/PlanCreate';
import { PlanDetail } from '../pages/PlanDetail';
import { PlanEdit } from '../pages/PlanEdit';

export const smrAdminRoutes: RouteObject[] = [
    {
        path: 'smr-admin',
        element: <InternalRoute />,
        children: [
            { path: 'services/:id', element: <ServiceDetail />, handle: FULL_WIDTH_PAGE },
            { path: 'services/:id/edit', element: <ServiceEdit /> },
            {
                element: <PermissionRoute requiredPermissions={[{ resource: 'smr', action: 'item.browse' }]} />,
                children: [
                    { path: 'items', element: <ItemList /> },
                ],
            },
            { path: 'items/new', element: <ItemDetail isNew /> },
            { path: 'items/:id', element: <ItemDetail /> },
            {
                element: <PermissionRoute requiredPermissions={[{ resource: 'smr', action: 'fee.browse' }]} />,
                children: [
                    { path: 'fees', element: <FeeList /> },
                ],
            },
            { path: 'fees/new', element: <FeeDetail isNew /> },
            { path: 'fees/:id', element: <FeeDetail /> },
            {
                element: <PermissionRoute requiredPermissions={[{ resource: 'smr', action: 'config-option.browse' }]} />,
                children: [
                    { path: 'config-options', element: <ConfigOptionList /> },
                ],
            },
            { path: 'config-options/:id', element: <ConfigOptionDetail /> },
            {
                element: <PermissionRoute requiredPermissions={[{ resource: 'smr', action: 'product.browse' }]} />,
                children: [
                    { path: 'products', element: <ProductList /> },
                ],
            },
            { path: 'products/new', element: <ProductCreate /> },
            { path: 'products/:id', element: <ProductDetail />, handle: FULL_WIDTH_PAGE },
            { path: 'products/:id/edit', element: <ProductEdit /> },
            {
                element: <PermissionRoute requiredPermissions={[{ resource: 'smr', action: 'addon.browse' }]} />,
                children: [{ path: 'addons', element: <AddOnList /> }],
            },
            {
                element: <PermissionRoute requiredPermissions={[{ resource: 'smr', action: 'addon.add' }]} />,
                children: [{ path: 'addons/new', element: <AddOnCreate /> }],
            },
            {
                element: <PermissionRoute requiredPermissions={[{ resource: 'smr', action: 'addon.read' }]} />,
                children: [{ path: 'addons/:id', element: <AddOnDetail /> }],
            },
            {
                element: <PermissionRoute requiredPermissions={[{ resource: 'smr', action: 'addon.edit' }]} />,
                children: [{ path: 'addons/:id/edit', element: <AddOnEdit /> }],
            },
            {
                element: <PermissionRoute requiredPermissions={[{ resource: 'smr', action: 'addon-group.browse' }]} />,
                children: [{ path: 'addon-groups', element: <AddOnGroupList /> }],
            },
            {
                element: <PermissionRoute requiredPermissions={[{ resource: 'smr', action: 'addon-group.add' }]} />,
                children: [{ path: 'addon-groups/new', element: <AddOnGroupCreate /> }],
            },
            {
                element: <PermissionRoute requiredPermissions={[{ resource: 'smr', action: 'addon-group.read' }]} />,
                children: [{ path: 'addon-groups/:id', element: <AddOnGroupDetail /> }],
            },
            {
                element: <PermissionRoute requiredPermissions={[{ resource: 'smr', action: 'addon-group.edit' }]} />,
                children: [{ path: 'addon-groups/:id/edit', element: <AddOnGroupEdit /> }],
            },
            {
                element: <PermissionRoute requiredPermissions={[{ resource: 'smr', action: 'plan.browse' }]} />,
                children: [{ path: 'plans', element: <PlanList /> }],
            },
            {
                element: <PermissionRoute requiredPermissions={[{ resource: 'smr', action: 'plan.add' }]} />,
                children: [{ path: 'plans/new', element: <PlanCreate /> }],
            },
            {
                element: <PermissionRoute requiredPermissions={[{ resource: 'smr', action: 'plan.read' }]} />,
                children: [{ path: 'plans/:id', element: <PlanDetail />, handle: FULL_WIDTH_PAGE }],
            },
            {
                element: <PermissionRoute requiredPermissions={[{ resource: 'smr', action: 'plan.edit' }]} />,
                children: [{ path: 'plans/:id/edit', element: <PlanEdit /> }],
            },
        ],
    },
];
